<app-pat-create-dialog
  [visible]="result() === null && !closed()"
  [isBusy]="creating()"
  [createdToken]="null"
  [scopesSource]="scopesSource"
  [expiryRequired]="true"
  [fixedName]="tokenName"
  titleKey="agentTokens.bulk.title"
  (create)="onCreate($event)"
  (visibleChange)="onDialogVisibleChange($event)"
/>

<ng-template #resultTemplate>
  @if (result(); as current) {
    <div class="agent-tokens-bulk" data-testid="agent-tokens-bulk-result">
      <p class="agent-tokens-bulk__summary">
        {{
          'agentTokens.bulk.summary'
            | translate: { created: current.created.length, total: current.created.length + current.failed.length }
        }}
      </p>
      @if (current.created.length > 0) {
        <p class="agent-tokens-bulk__once-hint">
          <mat-icon class="agent-tokens-bulk__once-icon" aria-hidden="true">warning_amber</mat-icon>
          {{ 'agentTokens.bulk.onceHint' | translate }}
        </p>
      }
      @if (current.failed.length > 0) {
        <div class="agent-tokens-bulk__failed" role="alert">
          <p class="agent-tokens-bulk__failed-label">{{ 'agentTokens.bulk.failedLabel' | translate }}</p>
          <ul class="agent-tokens-bulk__failed-list">
            @for (failure of current.failed; track failure.kuerzel) {
              <li class="agent-tokens-bulk__failed-item">
                <span class="agent-tokens-bulk__failed-kuerzel">{{ failure.kuerzel }}</span>
                – {{ failure.reasonKey | translate: { name: tokenName } }}
              </li>
            }
          </ul>
        </div>
      }
      <div class="agent-tokens-bulk__actions">
        <button mat-stroked-button type="button" data-testid="agent-tokens-bulk-close" (click)="requestClose()">
          {{ 'agentTokens.bulk.close' | translate }}
        </button>
        @if (current.created.length > 0) {
          <button mat-flat-button type="button" data-testid="agent-tokens-bulk-download" (click)="download()">
            <mat-icon aria-hidden="true">download</mat-icon>
            {{ 'agentTokens.bulk.download' | translate }}
          </button>
        }
      </div>
    </div>
  }
</ng-template>

<lib-modal
  [closeLabel]="'general.close' | translate"
  data-testid="agent-tokens-bulk-result-modal"
  [visible]="result() !== null && !confirmingDiscard()"
  [title]="'agentTokens.bulk.resultTitle' | translate"
  [contentTemplate]="resultTemplate"
  [showButtons]="false"
  (visibleChange)="!$event && requestClose()"
></lib-modal>

<lib-modal
  [closeLabel]="'general.close' | translate"
  data-testid="agent-tokens-bulk-discard"
  [visible]="confirmingDiscard()"
  [title]="'agentTokens.bulk.discardConfirm.title' | translate"
  [text]="'agentTokens.bulk.discardConfirm.message' | translate"
  [saveText]="'agentTokens.bulk.discardConfirm.confirm' | translate"
  [cancelText]="'agentTokens.bulk.discardConfirm.cancel' | translate"
  (save)="close()"
  (visibleChange)="!$event && confirmingDiscard.set(false)"
></lib-modal>
